import { dew as _abiDew } from "../../errors/abi.js";
import { dew as _concatDew } from "../data/concat.js";
import { dew as _encodeAbiParametersDew } from "./encodeAbiParameters.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.encodeDeployData = void 0;
  const abi_js_1 = _abiDew();
  const concat_js_1 = _concatDew();
  const encodeAbiParameters_js_1 = _encodeAbiParametersDew();
  const docsPath = "/docs/contract/encodeDeployData";
  function encodeDeployData({
    abi,
    args,
    bytecode
  }) {
    if (!args || args.length === 0) return bytecode;
    const description = abi.find(x => "type" in x && x.type === "constructor");
    if (!description) throw new abi_js_1.AbiConstructorNotFoundError({
      docsPath
    });
    if (!("inputs" in description)) throw new abi_js_1.AbiConstructorParamsNotFoundError({
      docsPath
    });
    if (!description.inputs || description.inputs.length === 0) throw new abi_js_1.AbiConstructorParamsNotFoundError({
      docsPath
    });
    const data = (0, encodeAbiParameters_js_1.encodeAbiParameters)(description.inputs, args);
    return (0, concat_js_1.concatHex)([bytecode, data]);
  }
  exports.encodeDeployData = encodeDeployData;
  //# sourceMappingURL=encodeDeployData.js.map
  return exports;
}